import { render, staticRenderFns } from "./carrierServices.vue?vue&type=template&id=9f72fea2&"
import script from "./carrierServices.vue?vue&type=script&lang=js&"
export * from "./carrierServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports